
let _ = require('../_.js');
let $ = jQuery;

_.Notification_Auction_Completed_Loser = class Notification_Auction_Completed_Loser {

    notification = null;

    constructor(notification) {
        this.notification = notification;
    }

    static _denied_modal_init = false;
    static _denied_modal_action = null;

    static hide_this_variations_details() {
        $("#completed-public-modal-did-not-win-text").hide();
        $("#completed-public-modal-looking-more-link-container-public").append($(".completed-public-modal-looking-more-link"));
    }

    $modal() {
        return $("#ac-modal-auction-completed-public-modal");
    }

    // auction_round_id, bid_id, is_tie_bid = false) {
    async on_show() {

        let deferred = $.Deferred();

        this.$modal().data('deferred', deferred);

        _.Notification_Auction_Completed_Winner.hide_this_variations_details();


        let meta;

        try {
            meta = JSON.parse(this.notification.meta)
        } catch (e) {
        }

        $("#completed-public-modal-did-not-win-text").show();
        $("#completed-public-modal-looking-more-link-container-participant").append($(".completed-public-modal-looking-more-link"));

        $("#completed-public-modal-am-name").text(meta.am_name);
        $("#completed-public-modal-am-phone").empty().append($("<a></a>").attr('a', 'tel:' + meta.am_phone).text(_.formatPhoneNumber(meta.am_phone)));
        $("#completed-public-modal-am-email").empty().append($("<a></a>").attr('a', 'mailto:' + meta.am_email).text(meta.am_email));

        this.$modal().find('.btn-show-auction-summary').show();

        this.$modal().modal_show();

        // Wait for the modal to close.
        await deferred.promise();

        await _.Lib_Notifications.dismiss_notification(this.notification.id);
    }

    async on_update() {
    }

    async on_hide() {
    }

}